<div class="flex bg-white rounded-xl shadow-lg border border-gray-200 h-[650px] overflow-hidden font-sans flex-col">
  <div class="flex flex-1 overflow-hidden">
    <aside class="w-64 border-r border-gray-200 bg-gray-50/50 overflow-y-auto">
      <div class="p-4 border-b border-gray-100 flex justify-between items-center">
        <span class="text-[11px] font-bold text-blue-600 uppercase tracking-widest">List Manager</span>
        <button
        (click)="createNormalList()"
        matRipple
        matTooltip="Create normal list"
        class="bg-blue-600 rounded-md">
        <lucide-angular [img]="PlusIcon" class="w-5 h-5 text-white cursor-pointer"></lucide-angular>
      </button>
      </div>
      <div class="p-4 border-b border-gray-100">
        <div class="relative flex items-center">
          <lucide-angular [img]="SearchIcon" class="absolute left-3 w-4 h-4 text-gray-400"></lucide-angular>
          <input 
            type="text" 
            placeholder="  Search..." 
            class="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400"
          />
        </div>
      </div>
      
      <div class="p-2 space-y-1">
        <!-- Normal Lists Section with nested constructed lists -->
        <div class="text-xs text-blue-600 uppercase font-bold tracking-wider px-2 py-1 mt-2">Lists</div>
         <div class="">
         <!-- <div class="overflow-y-auto h-[450px]"> -->
        @for (parent of sourceLists(); track parent.id) {
          <!-- Parent Normal List -->
          <div>
            <div 
              (click)="selectList(parent.name, ListType.NORMAL_LIST)"
              [class.bg-gray-200]="activeListName === parent.name && activeType === ListType.NORMAL_LIST"
              class="flex items-center justify-between p-2 text-sm text-gray-700 font-medium rounded-lg cursor-pointer hover:bg-gray-100 transition-all group">
              
              <div class="flex items-center gap-2">
                <span class="text-gray-400 text-xs">☰</span>
                {{ parent.name }}
              </div>
          
              <button 
                (click)="$event.stopPropagation(); createConstructedListFromParent(parent.id)"
                class="p-1 hover:bg-gray-100 rounded transition-colors"
                matRipple
                matTooltip="Create constructed list">
                <div class="flex items-center group-hover:bg-amber-50 rounded px-1 transition-colors">
                  <lucide-angular [img]="ZapIcon" class="w-3 h-3 text-amber-500"></lucide-angular>
                  <lucide-angular [img]="PlusIcon" class="w-4 h-4 text-blue-400 fill-amber-500 -ml-1"></lucide-angular>
                </div>
              </button>
            </div>
      
            <!-- Child Constructed Lists under this parent -->
            @if (getConstructedListsByParent(parent.id).length > 0) {
              <div class=" pl-2">
                @for (dyn of getConstructedListsByParent(parent.id); track dyn.id) {
                  <div 
                    (click)="selectList(dyn.name, ListType.CONSTRUCTED_LIST)"
                    [class.bg-blue-100]="activeListName === dyn.name"
                    [class.text-blue-700]="activeListName === dyn.name"
                    class="flex items-center gap-2 p-2 text-sm rounded-lg cursor-pointer transition-all hover:bg-gray-50">
                    <span class="text-blue-400 text-[10px]">⚡</span>
                    <span class="truncate">{{ dyn.name }}</span>
                  </div>
                }
              </div>
            }
          </div>
        }
        </div>
      </div>
    </aside>

    <main class="flex-1 p-8 overflow-y-auto">
      @if (activeType === ListType.NORMAL_LIST) {
        <div class="animate-in fade-in duration-300">
          <!-- editable title -->
            @if (!isEditingTitle) {
              <span
                class="text-2xl font-bold text-gray-800 cursor-pointer hover:text-blue-600 transition-colors inline-block"
                (click)="isEditingTitle = true;"
                matTooltip="Rename list"
              >
                {{ titleControl.value }}
              </span>
            }

            @if (isEditingTitle) {
              <app-input
                #titleInput
                inputStyle="H1 editable-title-input text-2xl font-bold text-gray-800"
                [formControl]="titleControl"
                [(isEditing)]="isEditingTitle"
                (save)="saveTitle()"
              />
            }

          <p class="text-sm text-gray-500 mb-6">Normal List Items</p>
          <div class="overflow-y-auto overflow-x-auto max-h-[400px] h-full">
          <lib-list-option-manager
          [activeListId]="activeListId"
          (hasChanges)="onNormalListChanges($event)"
        ></lib-list-option-manager>
      </div>
        </div>
      }

      @else {
        <div class="animate-in fade-in duration-300">
          <div class="flex justify-between items-start mb-6">
            <div>
              <!-- <h2 class="text-xl font-bold text-gray-800">{{ activeListName }}</h2> -->
                   <!-- editable title -->
            @if (!isEditingTitle) {
              <span
                class="text-2xl font-bold text-gray-800 cursor-pointer hover:text-blue-600 transition-colors inline-block"
                (click)="isEditingTitle = true;"
                matTooltip="Rename list"
              >
                {{ titleControl.value }}
              </span>
            }

            @if (isEditingTitle) {
              <app-input
                #titleInput
                inputStyle="H1 editable-title-input text-2xl font-bold text-gray-800"
                [formControl]="titleControl"
                [(isEditing)]="isEditingTitle"
                (save)="saveTitle()"
              />
            }
              <p class="text-sm text-gray-500">constructed list</p>
            </div>
          </div>
          <div class="bg-blue-50 text-blue-700 p-3 rounded-lg font-bold text-sm mb-8">List instructions</div>
          <div class="overflow-y-auto overflow-x-auto max-h-[380px] h-full">
          <div class="flex items-center mb-6  px-4">
            <label class="w-32 text-sm text-gray-500">Source list:</label>
            <div class="relative flex-1">
              <select [(ngModel)]="selectedSource" (ngModelChange)="onSelectedSourceChange($event)" class="w-full border border-gray-300 rounded-lg p-2.5 text-sm outline-none bg-white appearance-none pr-8">
                @for (list of sourceLists(); track list) {
                  <option [value]="list.name">{{ list.name }}</option>
                }
              </select>
              <lucide-angular [img]="ChevronDownIcon" class="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"></lucide-angular>
            </div>
          </div>
      
          <hr class="my-8 border-gray-100">

          <!-- Instruction Sets Container -->
          <div>
            @for (instrSet of instructionSets; track $index; let i = $index) {
              <div class=" px-4">

                <!-- Instruction Selector -->
                <div class="flex items-center mb-4">
                  <label class="w-32 text-sm text-gray-500">Instruction:</label>
                  <div class="relative flex-1">
                    <select [(ngModel)]="instrSet.selectedInstr" (ngModelChange)="detectChanges()" class="w-full border border-gray-300 rounded-lg p-2 text-sm outline-none bg-white appearance-none pr-8">
                      <option [value]="null" disabled selected hidden>Select an instruction...</option>
                      @for (instr of instructions; track instr.id) {
                        <option [value]="instr.id">{{ instr.label }}</option>
                      }
                    </select>
                    <lucide-angular [img]="ChevronDownIcon" class="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"></lucide-angular>
                  </div>

                <!-- Instruction with Remove Button -->
                  @if (instructionSets.length > 1) {
                    <button (click)="removeInstruction(i)" 
                            class="text-gray-400 hover:text-red-500 transition-colors p-2"
                            matTooltip="Remove instruction">
                      <lucide-angular [img]="TrashIcon" class="w-4 h-4"></lucide-angular>
                    </button>
                  } 
                </div>

                <!-- Dynamic Content Based on Selected Instruction -->
                @if (instrSet.selectedInstr === 'AIC' || instrSet.selectedInstr === 'ANC' || instrSet.selectedInstr === 'RIC') {
                  <div class="space-y-4">
                    <div class="flex items-start">
                      <label class="w-32 text-sm text-gray-500 mt-2">From question:</label>
                      <div class="flex-1">
                        <div class="relative">
                          <select 
                            [(ngModel)]="instrSet.questionSource" 
                            (ngModelChange)="detectChanges()" 
                            [class.border-red-500]="!instrSet.questionSource"
                            class="w-full border border-gray-300 rounded-lg p-2 text-sm bg-white appearance-none pr-8"
                          >
                            <option [value]="null" disabled selected hidden>Select a question...</option>
                            <!--  The "No Questions" fallback -->
                            @if (questions.length === 0) {
                              <option [value]="null" disabled>
                                The source list is not used in any eligible questions.
                              </option>
                            } @else {
                            <!--  Show eligible questions if they exist -->
                              @for (question of questions; track question.id) {
                                <option [value]="question.id">{{ question.name }}</option>
                              }
                            }
                          </select>
                          
                          <lucide-angular 
                            [img]="ChevronDownIcon" 
                            class="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none">
                          </lucide-angular>
                        </div>
                    
                        <!-- Error message logic -->
                        @if (!instrSet.questionSource) {
                          <p class="text-red-500 text-xs font-medium italic mt-1">
                            Selection required for valid dynamic list logic
                          </p>
                        }
                      </div>
                    </div>
                
                    <!-- Target position for AIC and ANC only (not for RIC) -->
                    @if (instrSet.selectedInstr === 'AIC' || instrSet.selectedInstr === 'ANC') {
                      <div class="ml-32 pt-2">
                        <mat-slide-toggle [(ngModel)]="instrSet.specifyPos" (ngModelChange)="detectChanges()" color="primary">
                          Specify target position
                        </mat-slide-toggle>
                        @if (instrSet.specifyPos) {
                          <div class="flex gap-2 mt-3">
                            <div class="relative w-1/2">
                              <select [(ngModel)]="instrSet.selectedPos" (ngModelChange)="detectChanges()" class="w-full border border-gray-300 rounded p-1.5 text-sm bg-white appearance-none pr-8">
                                @for (p of positions; track p) { 
                                  <option [value]="p">{{p}}</option> 
                                }
                              </select>
                              <lucide-angular [img]="ChevronDownIcon" class="absolute right-2 top-1/2 transform -translate-y-1/2 w-3 h-3 text-gray-400 pointer-events-none"></lucide-angular>
                            </div>
                            @if (instrSet.selectedPos === 'custom position') {
                              <input type="number" [(ngModel)]="instrSet.customPosition" (ngModelChange)="detectChanges()" placeholder="0" class="border border-gray-300 rounded p-1.5 w-1/2 text-sm">
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                }

                @if (instrSet.selectedInstr === 'ADD' || instrSet.selectedInstr === 'REMOVE') {
                  <div class="space-y-4">
                    <div class="flex items-center">
                      <label class="w-32 text-sm text-gray-500">From List:</label>
                      <div class="relative flex-1">
                        <select [(ngModel)]="instrSet.itemSource"  (ngModelChange)="onItemSourceChange(instrSet, i)"  class="w-full border border-gray-300 rounded-lg p-2 text-sm bg-white appearance-none pr-8 focus:outline-none">
                          <option [value]="null" disabled selected hidden>Select a list...</option>
                          @for (list of getAvailableListsForSource(selectedSource); track list)
                           { <option [value]="list">{{list}}</option> }
                        </select>
                        <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <lucide-angular [img]="ChevronDownIcon" class="w-4 h-4 text-gray-400"></lucide-angular>
                        </div>
                      </div>
                    </div>
                
                    @if (instrSet.itemSource) {
                      
                      @if (isConstructedList(instrSet.itemSource)) {
                        <div class="space-y-4">
                          <div class="flex items-center">
                            <label class="w-32 text-sm text-gray-500">Items:</label>
                            <div class="relative flex-1">
                              <select [(ngModel)]="instrSet.selectedDynamicItem" (ngModelChange)="detectChanges()" class="w-full border border-gray-300 rounded-lg p-2 text-sm bg-white appearance-none pr-8 focus:outline-none">
                                @for (itemType of dynamicItems; track itemType) {
                                  <option [value]="itemType">{{ itemType }}</option>
                                }
                              </select>
                              <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                <lucide-angular [img]="ChevronDownIcon" class="w-4 h-4 text-gray-400"></lucide-angular>
                              </div>
                            </div>
                          </div>
                
                          @if (instrSet.selectedDynamicItem === 'single item') {
                            <div class="flex items-start">
                              <label class="w-32 text-sm text-gray-500 pt-2">Item Position:</label>
                              
                              <div class="flex flex-col flex-1">
                                <input 
                                  #singleInput 
                                  type="number" 
                                  [(ngModel)]="instrSet.singleItemValue" (ngModelChange)="detectChanges()"
                                  class="w-1/2 border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                  placeholder="0"
                                >
                                
                                @if (!singleInput.value) {
                                  <span class="text-red-500 text-[10px] mt-1">
                                    Input required for valid dynamic list logic
                                  </span>
                                }
                              </div>
                            </div>
                          }
                          
                          @if (instrSet.selectedDynamicItem === 'range') {
                            <div class="flex items-start">
                              <label class="w-32 text-sm text-gray-500 pt-2">Between:</label>
                              
                              <div class="flex flex-col flex-1">
                                <div class="flex items-center gap-3 w-full">
                                  
                                  <div class="flex-1">
                                    <input 
                                      #startRange 
                                      type="number" 
                                      [(ngModel)]="instrSet.rangeStart"
                                      class="w-full border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                      placeholder="Start"
                                    >
                                  </div>
                            
                                  <span class="text-sm text-gray-400 font-medium whitespace-nowrap">and</span>
                                  
                                  <div class="flex-1">
                                    <input 
                                      #endRange 
                                      type="number" 
                                      [(ngModel)]="instrSet.rangeEnd"
                                      class="w-full border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                      placeholder="End"
                                    >
                                  </div>
                                </div>
                                
                                @if (!startRange.value || !endRange.value) {
                                  <span class="text-red-500 text-[10px] mt-1">
                                    Input required for valid dynamic list logic
                                  </span>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } 
                      
                      @else {
                        <div class="flex items-start">
                          <label class="w-32 text-sm text-gray-500 pt-2">Items:</label>
                          <div class="flex flex-col flex-1">
                            <div class="relative w-full">
                              <button 
                                (click)="toggleOptionDropdownForSet(i)" 
                                class="w-full border border-gray-300 rounded-lg p-2 text-sm bg-white flex justify-between items-center focus:outline-none"
                              >
                                <span class="text-gray-500">
                                  {{ instrSet.selectedItems.length > 0 ? instrSet.selectedItems.length + ' item(s) selected' : 'Select items...' }}
                                </span>
                                <lucide-angular 
                                  [img]="ChevronDownIcon" 
                                  class="w-4 h-4 text-gray-400 transition-transform" 
                                  [class.rotate-180]="dropdownOpenStates[i]">
                                </lucide-angular>
                              </button>
                              
                              @if (dropdownOpenStates[i]) {
                                <div class="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg p-2 max-h-[200px] overflow-y-auto">
                                  @for (item of listItems; track item) {
                                    <label class="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-1 rounded">
                                      <input 
                                        type="checkbox" 
                                        [checked]="instrSet.selectedItems.includes(item)" 
                                        (change)="toggleOptionForSet(i, item)" 
                                        class="rounded border-gray-300 text-blue-600" 
                                      />
                                      <span class="text-sm text-gray-700">{{ item }}</span>
                                    </label>
                                  }
                                </div>
                              }
                            </div>
                        
                            @if (instrSet.selectedItems.length > 0) {
                              <div class="flex flex-wrap gap-2 mt-2">
                                @for (item of instrSet.selectedItems; track item) {
                                  <span class="inline-flex items-center gap-1 px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-full">
                                    {{ item }}
                                    <button (click)="removeOptionFromSelected(i, item)" type="button" class="hover:text-blue-900">
                                      <lucide-angular [img]="XIcon" class="w-3 h-3"></lucide-angular>
                                    </button>
                                  </span>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      }
                
                      @if (instrSet.selectedInstr === 'ADD') {
                        <div class="ml-32 pt-2">
                          <mat-slide-toggle [(ngModel)]="instrSet.specifyPos" (ngModelChange)="detectChanges()" color="primary">
                            Specify item(s) target position
                          </mat-slide-toggle>
                          @if (instrSet.specifyPos) {
                            <div class="flex gap-2 mt-3">
                              <div class="relative w-1/2">
                                <select [(ngModel)]="instrSet.selectedPos" class="w-full border border-gray-300 rounded p-1.5 text-sm bg-white appearance-none pr-8">
                                  @for (p of positions; track p) { 
                                    <option [value]="p">{{p}}</option> 
                                  }
                                </select>
                                <lucide-angular [img]="ChevronDownIcon" class="absolute right-2 top-1/2 transform -translate-y-1/2 w-3 h-3 text-gray-400 pointer-events-none"></lucide-angular>
                              </div>
                              @if (instrSet.selectedPos === 'custom position') {
                                <input type="number"   [(ngModel)]="instrSet.customPosition" placeholder="0" class="border border-gray-300 rounded p-1.5 w-1/2 text-sm">
                              }
                            </div>
                          }
                        </div>
                      }
                    }
                  </div>
                }

                @if (instrSet.selectedInstr === 'RANDOMIZE') {
                  <div class="ml-32 space-y-3">
                    <mat-slide-toggle
                      [(ngModel)]="instrSet.specifyRange"
                      color="primary"
                      labelPosition="after"
                    >
                      Specify randomization range
                    </mat-slide-toggle>
                    @if (instrSet.specifyRange) {
                      <div class="flex gap-2 animate-in slide-in-from-top-1">
                        <input type="number" [(ngModel)]="instrSet.rangeStart" (ngModelChange)="detectChanges()" placeholder="Start" class="border border-gray-300 rounded p-2 flex-1 w-1/2 text-sm">
                        <input type="number" [(ngModel)]="instrSet.rangeEnd" (ngModelChange)="detectChanges()" placeholder="End" class="border border-gray-300 rounded p-2 flex-1 w-1/2 text-sm">
                      </div>
                    }
                  </div>
                }

                @if (instrSet.selectedInstr === 'LIST_LENGTH') {
                  <div class="flex items-start gap-4 ml-32">
                    <div class="w-1/2 relative h-fit">
                      <select [(ngModel)]="instrSet.limitType" (ngModelChange)="detectChanges()" class="w-full border border-gray-300 rounded-lg p-2 text-sm bg-white appearance-none pr-8 focus:outline-none">
                        @for (opt of limitTypes; track opt) { 
                          <option [value]="opt">{{opt}}</option> 
                        }
                      </select>
                      <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <lucide-angular 
                          [img]="ChevronDownIcon" 
                          class="w-4 h-4 text-gray-400">
                        </lucide-angular>
                      </div>
                    </div>
                    <div class="w-1/2 flex flex-col">
                      <input 
                        #numInput
                        [(ngModel)]="instrSet.limitValue"
                        (ngModelChange)="detectChanges()"
                        type="number" 
                        class="w-full border border-gray-300 rounded-lg p-2 text-sm focus:outline-none" 
                        placeholder="0">
                      @if (!numInput.value) {
                        <span class="text-red-500 text-[10px] mt-1 leading-tight"> Selection required for valid dynamic list logic</span>
                      }
                    </div>
                  </div>
                }

                @if (instrSet.selectedInstr === 'CUSTOM_SCRIPT') {
                  <textarea class="w-full h-32 border border-gray-300 rounded-xl p-4 font-mono text-xs bg-gray-50 mt-2 focus:ring-2 focus:ring-blue-100 outline-none transition-all" placeholder="// write logic here..."></textarea>
                }

                <!-- Divider between instructions (except after last) -->
                @if (i < instructionSets.length - 1) {
                  <hr class="my-6 border-gray-200">
                }
              </div>
            }
          </div>
 
          <!-- Add Instruction Button -->
          <div class="mt-4">
            <button (click)="addInstruction()"
            class="text-blue-600 font-semibold hover:text-blue-700 transition-colors text-sm flex items-center gap-1 bg-transparent border-none cursor-pointer p-0"
          >
            <lucide-angular [img]="PlusIcon" class="w-4 h-4"></lucide-angular>
            Add Instruction
          </button>
          </div>
        </div>
        </div>
      }
    </main>
  </div>

  <hr class="border-t border-gray-200">
  @if (showCancelWarning) {
    <div class="mx-4  mt-3 mb-2 p-4 bg-amber-50 border border-amber-200 rounded-xl flex flex-col gap-3 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <div class="flex items-center gap-2 text-amber-800">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
        </svg>
        <span class="font-semibold text-sm">Unsaved changes will be lost.</span>
      </div>
      
      <div class="flex justify-end gap-2">
        <button 
          (click)="stayAndEdit()" 
          class="text-xs font-bold text-amber-700 px-3 py-1 hover:bg-amber-100 rounded-lg transition">
          Keep Editing
        </button>
        <button 
          (click)="closeDialog()" 
          class="text-xs font-bold bg-amber-600 text-white px-4 py-1 rounded-lg shadow-md hover:bg-amber-700 transition">
          Discard Anyway
        </button>
      </div>
    </div>
  }
  
  <div class="px-4 py-6 flex justify-end gap-3">
    <button 
      class="bg-red-50 text-red-500 px-8 py-2 rounded-xl font-bold shadow-sm transition hover:bg-red-100 disabled:opacity-50"
      [disabled]="showCancelWarning"
      (click)="onCancel()">
      Cancel
    </button>
    
    <button 
      class="text-white px-8 py-2 rounded-xl font-bold shadow-lg transition" 
      [class.bg-blue-600]="hasChanges && !showCancelWarning"
      [class.bg-gray-400]="!hasChanges || showCancelWarning"
      [class.cursor-pointer]="hasChanges && !showCancelWarning"
      [class.cursor-not-allowed]="!hasChanges || showCancelWarning"
      [class.hover:bg-blue-700]="hasChanges && !showCancelWarning"
      [disabled]="!hasChanges || showCancelWarning"
      (click)="onDone()">
      Save
    </button>
  </div>
</div>